import ClassNames from "classnames";
import { FunctionComponent } from "react";
import styles from "../stylesheets/components/header-action-bottom-bar.module.css";
import {
  Accommodation,
  ActionLinks,
  ColorScheme,
  Language,
} from "../types/index.js";
import { css } from "../utils/emotion.js";
import { getActionAndContactLinks } from "../utils/utils.js";
import Icon from "./Icon.js";
import SmartLink from "./SmartLink.js";

interface Props {
  isPreview: boolean;
  actionLinks: ActionLinks;
  accommodation: Accommodation;
  scheme: ColorScheme;
  languageId: Language;
}

const HeaderActionBottomBar: FunctionComponent<Props> = ({
  accommodation,
  actionLinks,
  isPreview,
  scheme,
  languageId,
}) => {
  const items = getActionAndContactLinks(
    accommodation,
    actionLinks,
    languageId,
  );
  if (!items.length) return null;

  return (
    <div
      className={ClassNames(
        styles.HeaderActionBottomBar,
        css({
          backgroundColor: scheme.main.background,
          color: scheme.main.text,
        }),
      )}
    >
      <ul className={styles.HeaderActionBottomBar__List}>
        {items.map(({ children, icon, href }, index) => (
          <li key={index}>
            <SmartLink
              isPreview={isPreview}
              anchorAttrs={{
                href,
                className: styles.HeaderActionBottomBar__LinkItem,
              }}
            >
              <Icon
                glyph={icon}
                className={styles.HeaderActionBottomBar__Icon}
              />
              <span>{children}</span>
            </SmartLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HeaderActionBottomBar;
